import React from 'react'
import './App.css';
import { Card, CardActions, CardContent, CardMedia, Typography, Button, Grid, Collapse } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';

 const Plans = () => {
    const [expanded, setExpanded] = React.useState(false);

   
    const handleExpandClick = (id) => {
        setExpanded(prevExpanded => ({
            ...prevExpanded,
            [id]: !prevExpanded[id]  
        }));
    };

    const cardData = [
        {
            id: 1,
            title: "Sunny Loft",
            description: "Beautiful loft with plenty of natural light and open space.",
            price: "500/sqt",
            imageUrl: "/static/images/cards/loft.jpg",
            details: "This loft features modern architecture with 3 bedrooms and 2 bathrooms."
        },
        {
            id: 2,
            title: "Apartment",
            description: "High-rise with stunning city views and modern amenities.",
            price: "3,000/sqt",
            imageUrl: "/static/images/cards/apartment.jpg",
            details: "Located in the heart of downtown, this apartment includes access to a gym and rooftop pool."
        },
        {
            id: 3,
            title: "Cozy Cottage",
            description: "A charming cottage located in the countryside and resorts",
            price: "1,000/sqt",
            imageUrl: "/static/images/cards/cottage.jpg",
            details: "Perfect for getaways, with a beautiful garden and plenty of privacy."
        },
        {
            id: 4,
            title: "Luxury Villa",
            description: "A spacious villa with a private pool and beachfront view.",
            price: "2,000/sqt",
            imageUrl: "/static/images/cards/villa.jpg",
            details: "Features include a gourmet kitchen, 5 bedrooms, and a private dock."
        },
       
    ];
  return (
    <div className="text-center" id="pricing">
{/* <h6 className="text-success" style={{letterSpacing:'1px',fontStyle:'oblique'}}>Are you set</h6>
<h4 style={{color:"hsl(255, 93%, 30%)",letterSpacing:'2px'}}>TO DESIGN YOUR IDEAL HOME?</h4>
<p className="text-light" style={{letterSpacing:'1px'}}>Discover Our Tailored Building Solutions, Featuring Exclusive Materials, Efficient Processes, and Custom Design Options.</p>
<div className="m-5 ">
            <Grid container spacing={3}>
                {cardData.map((card, index) => (
                    <Grid item xs={12} sm={6} md={3} key={card.id}>
                        <Card className={`cards ${index === 2 ? 'scale-default' : ''}`} style={{boxShadow:'4px 0 40px 0 rgba(0, 0, 255, 0.2)',backgroundColor:'#eeee'}}>
                            <CardMedia 
                                 component="img"
                                 height="140"
                                //  image={card.imageUrl}
                                // alt={card.title}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h6" component="div">
                                    {card.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {card.description}
                                </Typography>
                                <Typography gutterBottom variant="h6" component="div">
                                <i class="bi bi-currency-rupee"></i>{card.price}
                                </Typography>
                            </CardContent>
                           
                                <>
                                <CardActions sx={{justifyContent:'flex-end'}} >
                                <IconButton
                                    onClick={() => handleExpandClick(card.id)} sx={{color:'green'}}
                                >
                                    <ExpandMoreIcon />
                                </IconButton>
                            </CardActions>
                            <Collapse in={expanded[card.id]} timeout="auto" unmountOnExit>
                                <CardContent>
                                    <Typography paragraph>{card.details}</Typography>
                                </CardContent>
                                    </Collapse>
                                </>
                          
                              
                           
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </div> */}
    
    </div>
  )
}
export default Plans;